import { BaseService } from './BaseService'
import type { IAudiEvento } from '../interfaces/tablas/IAudiEvento'

export class TrazabilidadService extends BaseService<IAudiEvento> {
  constructor() {
    super({ baseUrl: 'auditoria/trazabilidad/' })
  }
}
